import { CorpOrderMapper } from "@/adapters/CorpOrder.mapper";
import { withCorpGuard } from "@/services/corp/corpGuard";
import { toB2BError, toDataShapeError } from "@/utils/b2bErrors";
import { lazyService } from "@/utils/lazyMock";
import { supabase } from "@/utils/supabase";
export class CorpOrdersService {
    async list(companyId, filters = {}) {
        return withCorpGuard((async () => {
            let query = supabase()
                .from("corp_my_orders")
                .select("*")
                .eq("company_id", companyId)
                .order("created_at", { ascending: false });
            if (filters.status)
                query = query.eq("status", filters.status);
            if (filters.linkId)
                query = query.eq("link_id", filters.linkId);
            // BR-4 (UC1132, Q-B): период фильтра — по плановой дате `scheduled_date`.
            if (filters.scheduledFrom)
                query = query.gte("scheduled_date", filters.scheduledFrom);
            if (filters.scheduledTo)
                query = query.lt("scheduled_date", filters.scheduledTo);
            const { data, error } = await query;
            if (error)
                throw toB2BError(error);
            try {
                return (data ?? []).map(CorpOrderMapper.rowToDomain);
            }
            catch (parseError) {
                throw toDataShapeError(parseError);
            }
        })());
    }
    async getOne(companyId, orderId) {
        return withCorpGuard((async () => {
            const { data, error } = await supabase()
                .from("corp_my_orders")
                .select("*")
                .eq("company_id", companyId)
                .eq("order_id", orderId);
            if (error)
                throw toB2BError(error);
            const rows = data ?? [];
            if (rows.length === 0)
                return null;
            try {
                return CorpOrderMapper.rowToDomain(rows[0]);
            }
            catch (parseError) {
                throw toDataShapeError(parseError);
            }
        })());
    }
}
// Литерал REACT_APP_B2B_MOCK — см. CompanyLinkService.ts / utils/lazyMock.ts (G4).
export const corpOrdersService = process.env.REACT_APP_B2B_MOCK === "true"
    ? lazyService(() => import("@/services/corp/CorpOrdersServiceMock").then((module) => module.corpOrdersServiceMock))
    : new CorpOrdersService();
